export default __webpack_public_path__ + "static/media/bmw.8dd9b8f7.svg";